import React, { useState, useEffect } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList, Text } from 'recharts';
import { Radio, Empty, Select, TreeSelect, DatePicker, Button, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { mesesArrayL as months } from '../helpers/const'
import { formatMinCurrency, onlyTwoDigitsV2 } from '../helpers/formatter'

import moment from 'moment'
import { colorArray } from '../helpers/const'
const { Option } = Select;
const { TreeNode } = TreeSelect;


function ChartRG(props) {
	const selectData = props.select ? props.select : {}
	const selectStatus = props.selectStatusChart ? props.selectStatusChart : {}
	const dataChart = props.dataChart ? props.dataChart : {}

    console.log(selectData)
	useEffect(() => {

		if (!selectData.new) {
			checkLocalSelectData()
		}

	}, [])

	const tooltipFormaterCurrency = (value, name, props) => {
		let key = props.dataKey;
		value = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			maximumFractionDigits: 0,
		}).format(value)
		return value
	}

	const tooltipFormaterOnlyTwoDigits = (value, name, props) => {
		let key = props.dataKey;
		value = new Intl.NumberFormat('en-US', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 2,
		}).format(value)
		return value
	}

	const tooltipFormaterPercent = (value, name, props) => {
		let key = props.dataKey;
		value = new Intl.NumberFormat('en-US', {
			minimumFractionDigits: 0,
			maximumFractionDigits: 2,
		}).format(value)
		return value + "%"
	}


	function typeFormater(data) {
		let pre = ""

		if (data) {
			if (data.length > 0) {
				pre = data[0].pre
			}
		}

		return pre
	}


	function linesChart(typeChart, brand, typeItem, data) {
		let cloneData = JSON.parse(JSON.stringify(data))

		let offsetColors = 0

		switch (typeChart) {
			case "semi":
				offsetColors = 0
				break
			case "service":
				offsetColors = 0
				break
			case "expenses":
				offsetColors = 0
				break
			default:
		}

		let groupData = []
		let group = []

		if (cloneData) {

			cloneData.map((item, index) => {

				if (item.key !== typeItem) {
					if (groupData[item.tipo + ' ' + item.marca_unidad] === undefined) {
						groupData[item.tipo + ' ' + item.marca_unidad] = {
							type: "monotone", dataKey: (item.tipo + ' ' + item.marca_unidad),
							stroke: colorArray[offsetColors + item.id], name: (item.tipo + ' ' + item.marca_unidad), strokeDasharray: item.key === 0 ? "" : "5 5"
						}
					}
				}

			})
		}

		let line = []
		Object.keys(groupData).map(key => {

			line.push(groupData[key])

		})


		return line;
	}

	function formatDataChart(typeItem, data) {

		let cloneData = JSON.parse(JSON.stringify(data))

		let groupData = []
		let group = []

		if (cloneData) {


			cloneData.map((item) => {

				if (item.key !== typeItem) {
					if (groupData[item.mes] === undefined) {
						groupData[item.mes] = { key: item.mes, name: months[item.mes], pre: item.pre }
					}
					groupData[item.mes][item.tipo + ' ' + item.marca_unidad] = item.valor
				}

			})

		}

		let chart = []
		Object.keys(groupData).map(key => {

			chart.push(groupData[key])

		})



		return chart;
	}


	function loadData(type) {
		props.loadData(type)
	}

	function onChangeSelectIndicator(option, type, name, value) {
		props.onChangeSelectStatusChart(type, "group", option.group ? 1 : 0)

		props.onChangeSelectStatusChart(type, name, value)
	}

	function onChangeSelectBrand(option, type, name, value) {

		props.onChangeSelectStatusChart(type, name, value)
	}

	function onChangeRadio(type, name, value) {

		props.onChangeSelectStatusChart(type, name, value)
	}


	function onChangeDate(type, name, date) {
		if (date != null) {
			props.onChangeSelectStatusChart(type, name, Number(date.format("YYYY")))
		} else {
			props.onChangeSelectStatusChart(type, name, null)
		}
	}

	function checkLocalSelectData() {

		Object.keys(selectStatus).forEach(key => {
			if (selectStatus[key].idIndicator != null &&
				selectStatus[key].idBrand != null &&
				selectStatus[key].year != null) {
				if (!dataChart[key].data) {
					loadData(key)
				}
			}

		})
	}


	function itemChart(name, type) {

		return <div>
			<div className="dp-line">
				{name}

				<Select
					bordered={false}
					showSearch
					className="dp-chart-select"
					placeholder="Seleccionar indicador"
					optionFilterProp="children"
					onChange={(value, option) => onChangeSelectIndicator(option, type, "idIndicator", value)}
					value={selectData[type] ? selectStatus[type]["idIndicator"] : null}
					filterOption={(input, option) =>
						option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
					}>
					{selectData[type] ? selectData[type].map((item, index) => {
						return <Option key={index} group={item.group} value={item.id}>{item.name}</Option>
					}) : null}
				</Select>
				<Select
					bordered={false}
					showSearch
					mode="multiple"
					style={{ minWidth: "150px" }}
					placeholder="Marca"
					optionFilterProp="children"
					value={selectData.brands ? selectStatus[type]["idBrand"] : []}
					onChange={(value, option) => onChangeSelectBrand(option, type, "idBrand", value)}
					filterOption={(input, option) =>
						option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
					}>
					{selectData.brands ? selectData.brands.map((item, index) => {
						return <Option key={index} value={item.id}>{item.name}</Option>
					}) : null
					}
				</Select>
                    {console.log(type)}
				<DatePicker
					bordered={false}
					value={moment(selectStatus[type]["year"], "YYYY").isValid() ? moment(selectStatus[type]["year"], "YYYY") : null}
					format="YYYY"
					onChange={value => onChangeDate(type, "year", value)}
					placeholder="Fecha"
					style={{ minWidth: 120, marginRight: "8px" }}
					picker="year" />
				<Radio.Group className="dp-radio-chart" value={selectStatus[type]["vs"] ? selectStatus[type]["vs"] : 1}
					onChange={(e) => onChangeRadio(type, "vs", e.target.value)}>
					<Radio.Button value={2}>vs. año anterior</Radio.Button>
					<Radio.Button value={1}>vs. Ppto</Radio.Button>
				</Radio.Group>
				{/* <Button className="dp-chart-button" type="primary" onClick={() => loadData(type)}>
					Consultar
				</Button> */}
			</div>
			{dataChart[type].data ? <ResponsiveContainer
				className="dp-chart-responsive-chart"
				width="100%"
				height={500}>
				<LineChart
					width={500}
					height={400}
					data={formatDataChart(selectStatus[type]["vs"] ? selectStatus[type]["vs"] : 1, dataChart[type].data)}
					margin={{
						top: 30,
						right: 40,
						left: 0,
						bottom: 5,
					}}>
					<XAxis dataKey="name" />
					<YAxis domain={[dataMin => dataMin, dataMax => dataMax]} tickFormatter={typeFormater(dataChart[type].data) === "$" ? formatMinCurrency : onlyTwoDigitsV2} />
					<Tooltip formatter={typeFormater(dataChart[type].data) === "$" ? tooltipFormaterCurrency : (typeFormater(dataChart[type].data) === "%" ? tooltipFormaterPercent : tooltipFormaterOnlyTwoDigits)} />
					<Legend />
					{
						linesChart(type, selectStatus[type]["idBrand"], selectStatus[type]["vs"], dataChart[type].data).map((item, index) => {

							return <Line dot={null} key={index} isAnimationActive={false} type={item.type} dataKey={item.dataKey} name={item.name} stroke={item.stroke} strokeDasharray={item.strokeDasharray}>
								{item.strokeDasharray === "" ? <LabelList dataKey={item.dataKey} position="top"
									formatter={typeFormater(dataChart[type].data) === "$" ? formatMinCurrency : onlyTwoDigitsV2} /> : null}
							</Line>
						})
					}
				</LineChart>
			</ResponsiveContainer> : dataChart[type].loading ? <Spin className="dp-spin-chart" tip="Cargando..." indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} /> :
				<Empty
					className="dp-chart-empty"
					image={Empty.PRESENTED_IMAGE_SIMPLE}
					description="Click en consultar para ver la información" />}</div>

	}



	return (
		<div>
			{
				itemChart("Nuevos", "new")
			}
			{
				itemChart("Seminuevos", "semi")
			}
			{
				itemChart("Demos", "demos")
			}
			{
				itemChart("HDM", "hdm")
			}
			{
				itemChart("Resumen seguros", "seguros")
			}
			{
				itemChart("Postventa", "postventa")
			}
		</div>
	)

}

export default ChartRG